_   = require('underscore')
Vue = require('vue/dist/vue')

module.exports =
  namespaced: true

  state:
    collections:
      default: {}

  getters:

    isCollapsed: (state) -> (collection, id) ->
      (state.collections[collection] || {})[id] == true

  mutations:

    _setItem: (state, payload) ->
      return unless payload.collection? && payload.id?
      Vue.set(state.collections, payload.collection, {}) unless state.collections[payload.collection]?
      Vue.set(state.collections[payload.collection], payload.id, payload.collapsed == true)

    _removeItem: (state, payload) ->
      return unless payload.collection? && state.collections[payload.collection]?
      collection = _.omit(state.collections[payload.collection] || {}, payload.id)
      Vue.set(state.collections, payload.collection, {}) unless state.collections[payload.collection]?
      Vue.set(state.collections, payload.collection, collection)

    _updateState: (state, payload) ->
      return unless payload.collection? && state.collections[payload.collection]?
      collection = state.collections[payload.collection]
      _.each collection, (value, key) -> collection[key] = true
      collection[payload.id] = payload.collapsed == true
      Vue.set(state.collections, payload.collection, collection)

  actions:

    register: (context, payload) ->
      payload.collection  or= 'default'
      payload.id          or= _.uniqueId('accordion-')
      payload.collapsed   = true

      context.commit('_setItem', payload)

    unregister: (context, payload) ->
      payload.collection or= 'default'

      context.commit('_removeItem', payload) if payload.id?

    toggle: (context, payload) ->
      return unless context.state.collections[payload.collection]
      collapsed = context.state.collections[payload.collection][payload.id] == false

      context.commit('_updateState', {
        collection: payload.collection
        id:         payload.id
        collapsed:  collapsed
      })






// WEBPACK FOOTER //
// ./assets/js/frontend/store/accordion/index.coffee